export default __webpack_public_path__ + "static/media/41.ea016370.jpg";